import * as React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { context } from '../context';

// 直播形式的映射关系
const liveFormatMap = {
    '': '全部',
    1: '3D',
    2: '2D',
    3: '电台',
    4: '联动',
    5: '双播',
    6: '其它',
};

export const LiveFormatSelector = () => {
    const { selectedFormat, setSelectedFormat } = React.useContext(context);

    const handleChange = (event) => {
        setSelectedFormat(event.target.value);
    };

    return (
        <FormControl fullWidth size="small">
            <InputLabel 
                id="format-select-label"
                sx={{ 
                    fontSize: '0.875rem',
                    '&.Mui-focused': { color: 'primary.main' },
                }}
            >
                形式
            </InputLabel>
            <Select
                labelId="format-select-label"
                value={selectedFormat}
                label="形式"
                onChange={handleChange}
                sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(0, 0, 0, 0.1)',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'primary.light',
                    },
                    '& .MuiSelect-select': {
                        fontSize: '0.875rem',
                    },
                }}
            >
                {Object.entries(liveFormatMap).map(([key, value]) => (
                    <MenuItem 
                        key={key} 
                        value={key}
                        sx={{
                            fontSize: '0.875rem',
                            py: 1,
                            borderRadius: '6px',
                            mx: 0.5,
                            my: 0.25,
                        }}
                    >
                        {value}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};